import { EmptyWrapper } from './styles';

interface IEmpty {
  icon?: string;
  text?: string;
  iconStyle?: 'outlined' | 'two-tone' | 'round' | 'sharp';
  iconSize?: number;
}

/**
 * Componente que indica um estado de lista vazio
 * @param icon nome do material-icon - padrão: search
 * @param text a mensagem a ser exibida - padrão: Nenhum resultado encontrado
 * @param iconStyle o estilo do material-icon
 * @param iconSize o tamanho em px do material-icon - padrão: 75
 */
export const Empty: React.FC<IEmpty> = ({
  icon = 'search',
  text = 'Nenhum resultado encontrado',
  iconStyle,
  iconSize = 75,
}) => {
  return (
    <EmptyWrapper>
      <em
        className={`material-icons${iconStyle ? `-${iconStyle}` : ''}`}
        style={{ fontSize: iconSize }}
      >
        {icon}
      </em>
      <span>{text}</span>
    </EmptyWrapper>
  );
};
